import '../styles/menu.css'

import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'

import Image from 'react-bootstrap/Image'

import OpcaoMenu from './OpcaoMenuRedutor'

import constantes from '../helpers/constanteHelper'

import logo from '../images/logo-menu.png'

function Menu({ opcaoSelecionada }) {
    const navigate = useNavigate();

    const [width, setWidth] = useState(window.innerWidth);

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);
        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    const abrirMenu = () => {
        const nav = document.querySelector('nav')
        nav.classList.add('open-nav-rpc')
    }

    const fecharMenu = () => {
        const nav = document.querySelector('nav')
        nav.classList.add('closed-nav')
        nav.classList.remove('open-nav-rpc')
    }

    return (
        <>
            <header style={{ width: resolucaoMobile ? 'auto' : '95vw'}} className='mt-3 mx-1 d-flex align-items-center justify-content-space-evenly nav'>
                <div style={{ cursor: 'pointer', width: resolucaoMobile ? '70vw' : 'auto', textAlign: 'start' }} >
                    <Image onClick={() => { navigate(`../`) }} style={{ cursor: 'pointer'}} className='me-3' src={logo} alt='logo' fluid />
                </div>

                <nav>
                    <div className='close' onClick={fecharMenu}>
                        <svg xmlns='http://www.w3.org/2000/svg' height='48' width='48'>
                            <path d='M12.45 37.65 10.35 35.55 21.9 24 10.35 12.45 12.45 10.35 24 21.9 35.55 10.35 37.65 12.45 26.1 24 37.65 35.55 35.55 37.65 24 26.1Z' fill={constantes.CORES.BRANCO_PADRAO} />
                        </svg>
                    </div>
                    
                    <div style={{ gap: 1 }} className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center nav'>
                        <OpcaoMenu texto={'Sobre'} opcao={'sobre'} funcao={() => { navigate('/catalogo-rpc/sobre') }} opcaoSelecionada={opcaoSelecionada}></OpcaoMenu>
                        <OpcaoMenu texto={'Empresas'} opcao={'empresas'} funcao={() => { navigate('/catalogo-rpc/empresas') }} opcaoSelecionada={opcaoSelecionada}></OpcaoMenu>
                        <OpcaoMenu texto={'Produtos'} opcao={'produtos'} funcao={() => { navigate(`/catalogo-rpc/produtos`) }} opcaoSelecionada={opcaoSelecionada}></OpcaoMenu>
                    </div>
                </nav>
                <div></div>

                <div style={{ width: resolucaoMobile ? '20vw' : '100vw' }} className='menu d-flex align-items-center justify-content-end pe-3' onClick={abrirMenu}>
                    <svg className='menu' xmlns='http://www.w3.org/2000/svg' height='48' viewBox='0 -960 960 960' width='48'>
                        <path d='M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z' fill={constantes.CORES.BRANCO_PADRAO} />
                    </svg>

                </div>

            </header>

        </>



    );
}

export default Menu;
